<template>
  <div>
    <Logo :show="false" :isSwitchLanguage = "true" />
    <Cover/>
    <Intro/>
    <Destination />
    <Enquiry />
    <Footer />
    
  </div>
</template>

<script>
import Logo from "@/components/Logo.vue";
import Cover from '@/components/Cover.vue'
import Intro from '@/components/Intro.vue'
import Destination from '@/components/Destination.vue'
import Enquiry from '@/components/Enquiry.vue'
import Footer from '@/components/Footer.vue'




export default {
  name: 'home',
  components: {
    Logo, Cover, Intro, Destination, Enquiry, Footer
  },
  data() {
    return {
      lang: this.$route.params.lang,
      dialog: false
    }
  }
}
</script>
